import firebase from "firebase";
import GeoFire from "geofire";

var config = {
  apiKey: "AIzaSyByyhlriK2-7mtXbEqg-x97c42zWVfJMiE",
  authDomain: "tourbrazil-41fbe.firebaseapp.com",
  databaseURL: "https://tourbrazil-41fbe.firebaseio.com",
  projectId: "tourbrazil-41fbe",
  storageBucket: "tourbrazil-41fbe.appspot.com",
  messagingSenderId: "927605208400"
};

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

export const cadastro = (
  nome,
  email,
  senha,
  logotipo,
  categoria,
  rua,
  cidade,
  cep,
  cnpj,
  fone,
  face,
  site,
  lat,
  lng
) => {
  return dispatch => {
    dispatch({ type: "CADASTRO_STATE", payload: "Iniciando Cadastro" });
    firebase
      .auth()
      .createUserWithEmailAndPassword(email, senha)
      .then(user => {
        var createdAt = user.user.metadata.creationTime;
        enviarDados(
          dispatch,
          nome,
          email,
          logotipo,
          categoria,
          rua,
          cidade,
          cep,
          cnpj,
          fone,
          face,
          site,
          lat,
          lng,
          createdAt
        );
      })
      .catch(erro => {
        switch (erro.code) {
          case "auth/email-already-in-use":
            return dispatch({
              type: "CADASTRO_STATE",
              payload: "Este e-mail já está em uso."
            });
          case "auth/invalid-email":
            return dispatch({
              type: "CADASTRO_STATE",
              payload: "E-mail inválido."
            });
          case "auth/operation-not-allowed":
            return dispatch({
              type: "CADASTRO_STATE",
              payload: "Operação não autorizada."
            });
          case "auth/weak-password":
            return dispatch({
              type: "CADASTRO_STATE",
              payload: "Senha muito fraca."
            });
          default:
            return dispatch({
              type: "CADASTRO_STATE",
              payload: "Algo está errado."
            });
        }
      });
  };
};

const enviarDados = (
  dispatch,
  nome,
  email,
  logotipo,
  categoria,
  rua,
  cidade,
  cep,
  cnpj,
  fone,
  face,
  site,
  lat,
  lng,
  createdAt
) => {
  firebase.auth().onAuthStateChanged(user => {
    if (user) {
      dispatch({ type: "CADASTRO_STATE", payload: "Enviando dados" });
      var storageRef = firebase.database().ref("geo-emp");
      var geoFire = new GeoFire(storageRef);
      var id = user.uid;
      geoFire.set(id, [parseFloat(lat), parseFloat(lng)]).then(
        () => {
          console.log("Provided key has been added to GeoFire");
          firebase
            .database()
            .ref(`/empDados/${id}/`)
            .set({
              nome: nome,
              email: email,
              morada1: rua,
              morada2: cidade,
              cat: categoria,
              lat: parseFloat(lat),
              lng: parseFloat(lng),
              codPostal: cep,
              key: id,
              fone: fone,
              facebook: face,
              link: site,
              cnpj: cnpj,
              img: logotipo,
              createdAt
            })
            .then(value => {
              dispatch({
                type: "CADASTRO_STATE",
                payload: "Cadastro efetuado com sucesso"
              });
              return (window.location = "/home");
            })
            .catch(erro => {
              console.log(erro);
              return dispatch({
                type: "CADASTRO_STATE",
                payload: "Erro ao efetuar o Cadastro"
              });
            });
        },
        error => {
          console.log("Error: " + error);
        }
      );
    }
  });
};

export const editar = (
  nome,
  logotipo,
  categoria,
  rua,
  cidade,
  cep,
  cnpj,
  fone,
  face,
  site,
  lat,
  lng,
  imgOld
) => {
  return dispatch => {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        dispatch({ type: "CADASTRO_STATE", payload: "Enviando dados" });
        var id = user.uid;
        var storageRef = firebase.database().ref("geo-emp");
        var geoFire = new GeoFire(storageRef);
        var id = user.uid;
        geoFire.set(id, [parseFloat(lat), parseFloat(lng)]).then(() => {
          firebase
            .database()
            .ref(`/empDados/${id}/`)
            .set({
              nome: nome,
              email: user.email,
              morada1: rua,
              morada2: cidade,
              cat: categoria,
              lat: parseFloat(lat),
              lng: parseFloat(lng),
              codPostal: cep,
              key: id,
              fone: fone,
              facebook: face,
              link: site,
              cnpj: cnpj,
              img: logotipo ? logotipo : imgOld
            })
            .then(value => {
              dispatch({
                type: "CADASTRO_STATE",
                payload: "Cadastro efetuado com sucesso"
              });
              return (window.location = "/home");
            })
            .catch(erro => {
              console.log(erro);
              return dispatch({
                type: "CADASTRO_STATE",
                payload: "Erro ao efetuar o Cadastro"
              });
            });
        });
      }
    });
  };
};



// WEBPACK FOOTER //
// ./src/redux/actions/cadastro.js